module.exports = __webpack_public_path__ + "static/img/data-input.96520ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/data-input.svg
// module id = PznB
// module chunks = 0